import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox,
    CircularProgress

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import { fetchStitchingReturnlist, fetchStitchReturnGrpStid } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectKajeEmplist, selectKajeInwMemo, selectKajeInwReg, selectKajeMemoNo, selectPressEmplist, selectStitchReGrpStId, selectStitchReturn, selectStitchReturnMemo, selectTrimEmps, selectTrimMemo } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { KajeMenu, KjPrIssInwMenu, TrimmingMenu } from '../TitleList';
import { fetchKajeEmplist, fetchKajeMemoNo, fetchKajeReturnReg, fetchStitchReturnMemo, kajeEntry, kajePressIssueInward } from '../../Store/PHPSlice/Kaje/KajeApi';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import { fetchPressEmplist } from '../../Store/PHPSlice/Press/PressingApi';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import Dropdown from '../FieldsComponents/Dropdown';
import axios from 'axios';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import PreviewIcon from '@mui/icons-material/Preview';
import { fetchKajeInwMemo, fetchTrimmingEmplist, fetchTrimmingMemo, InsertTrimming } from '../../Store/PHPSlice/Trimming/TrimApi';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';

const TrimmingEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        kjnId: '',
        trMemo: '',
        kreMemo: '',
        depart: '',
        itemNm: '',
        itemId: '',
        empNm: '',
        empId: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        totQty: '',
        instructions: '',
        userId: userdata?.ID,
        mtotqty: 0,
        mtotissqty: 0
    });
    const [errors, setErrors] = useState({});
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [itemData, setItemData] = useState([]);
    const [balQtyValues, setBalQtyValues] = useState(Array(itemData?.length).fill('0'));
    const [issueQtyValues, setIssueQtyValues] = useState(Array(itemData?.length).fill('0'));
    const [tableData, setTableData] = useState([]);
    const [multiData, setMultiData] = useState([]);

    // State for selected rows
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const actionMap = {
        master: fetchStitchingReturnlist,
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const departlist = useSelector(selectDaparement);
    const kjInwMemo = useSelector(selectKajeInwMemo);
    const trimEmplist = useSelector(selectTrimEmps);
    const trimMemo = useSelector(selectTrimMemo);
    const kajeInwlist = useSelector(selectKajeInwReg);
    const firmlist = useSelector(selectFirm);
    // console.log(kajeInwlist);
    useEffect(() => {
        dispatch(fetchDepartmentData());
        dispatch(fetchTrimmingMemo());
        dispatch(fetchTrimmingEmplist());
        // dispatch(fetchKajeInwMemo());
        dispatch(fetchCompanyData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (trimMemo?.data) {
            const item = trimMemo?.data?.memo;
            // console.log(trimMemo);
            setFormData(prev => ({
                ...prev,
                trMemo: item
            }))
        }
    }, [trimMemo]);

    useEffect(() => {
        if (kajeInwlist?.data) {
            const res = kajeInwlist?.data;
            const totqty = kajeInwlist?.info?.reduce((a, s) => a + Number(s.tissqty || 0), 0);
            const totgqty = kajeInwlist?.info?.reduce((a, s) => a + Number(s.tqty || 0), 0);
            setFormData(prev => ({
                ...prev,
                item: res?.itemNm,
                itemId: res?.itemId,
                soId: res?.soId,
                sono: res?.sono,
                totQty: totgqty,
                mcloth: res?.mcloth,
                m1cloth: res?.m1cloth,
                m2cloth: res?.m2cloth,
                m3cloth: res?.m3cloth,
                mclothNm: res?.mclothNm,
                m1clothNm: res?.m1clothNm,
                m2clothNm: res?.m2clothNm,
                m3clothNm: res?.m3clothNm,
                kjMemo: res?.kjMemo,
                kreMemo: res?.kreMemo,
                kId: res?.kId,
                totissqty: totqty
            }));
            setTableData(kajeInwlist?.info);
        }
    }, [kajeInwlist]);


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        // fetchStitchingReturnlist
        switch (dropdownType) {
            case 'kjnId':
                if (value) {
                    // fetchStitchingReturnData(value);
                    dispatch(fetchKajeReturnReg(value));
                }
                break;
            case 'firmId':
                if (value) {
                    dispatch(fetchKajeInwMemo(value));
                }
                break;
            default:
                break;
        }
    };

    const fetchStitchingReturnData = async (id) => {
        try {
            // const response = await axios.get(`${baseUrl}?apicall=getStitchingReturndataForKaje&streId=${id}`);
            const response = await axios.get(`${baseUrl}?apicall=getStitchingReturnlist&sreId=${id}`);
            const res = response?.data?.data[0];
            // console.log(res);
            setFormData(prev => ({
                ...prev,
                item: res?.itemNm,
                itemId: res?.itemId,
                soId: res?.soId,
                sono: res?.sono,
                totQty: res?.reQty,
                mcloth: res?.mcloth,
                m1cloth: res?.m1cloth,
                m2cloth: res?.m2cloth,
                m3cloth: res?.m3cloth,
                mclothNm: res?.mclothNm,
                m1clothNm: res?.m1clothNm,
                m2clothNm: res?.m2clothNm,
                m3clothNm: res?.m3clothNm,
                stMemo: res?.stMemo,
                stId: res?.stId
            }));
            setTableData(response?.data?.Info);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Trimming Memo', name: 'trMemo', type: 'readOnly' },
    ];

    const fields2 = [
        { label: 'SO No', name: 'sono', type: 'readOnly' },
        { label: 'Item', name: 'item', type: 'readOnly' },
        { label: 'Total Qty', name: 'totissqty', type: 'readOnly' },
    ];
    // console.log(tableData);

    const dropdownOrdType = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Kaje Inward Memo',
            id: 'kjnId',
            options: kjInwMemo?.data || [],
            value: formData.kjnId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'kjnId', value: newValue ? newValue.ID : '' } }, 'kjnId'),
            getOptionLabel: (option) => option.kreMemo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        // {
        //     label: 'Employee',
        //     id: 'empId',
        //     options: trimEmplist?.data || [],
        //     value: formData.empId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
        //     getOptionLabel: (option) => option.empNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     bold: true
        // },
    ];

    const handleNewEmployee = () => {
        window.open(`/new-emp-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownEmployeelist = [
        {
            label: 'Employee',
            id: 'empId',
            options: trimEmplist?.data || [],
            value: formData.empId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNewEmployee(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('empId'),
            handleDropdownClose: () => handleDropdownClose('empId'),
        }
    ];

    const handleQtychange = (index, e) => {
        let value = e.target.value;

        // convert to number (if empty, set 0)
        value = value === "" ? 0 : parseInt(value, 10);

        // clone the array
        const updated = [...tableData];

        // restrict kissqty <= rqty
        const validTissqty = value > updated[index].tqty ? updated[index].tqty : value;

        // update that row
        updated[index] = {
            ...updated[index],
            tissqty: validTissqty,
            tbalqty: updated[index].tqty - validTissqty
        };

        const totissqty = updated?.reduce((acc, sum) => acc + parseFloat(sum.tissqty), 0);
        setFormData(prev => ({
            ...prev,
            totissqty: totissqty
        }));
        // set new state
        setTableData(updated);
    };


    const handleAddData = () => {

        const data = {
            kjnId: formData.kjnId,
            kreMemo: formData.kreMemo,
            kId: formData.kId,
            itemId: formData.itemId,
            itemNm: formData.item,
            soId: formData.soId,
            sono: formData.sono,
            totqty: formData.totQty,
            totissqty: formData.totissqty,
            kjMemo: formData.kjMemo,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth,
            m2cloth: formData.m2cloth,
            m3cloth: formData.m3cloth,
            mclothNm: formData.mclothNm,
            m1clothNm: formData.m1clothNm,
            m2clothNm: formData.m2clothNm,
            m3clothNm: formData.m3clothNm,
            tableData: tableData,
            instructions: formData.instructions,
            trMemo: formData.trMemo,
        };

        const prevMultiData = [...multiData];

        const isKjnIdExist = prevMultiData?.some(item => item.kjnId === data.kjnId);

        if (isKjnIdExist) {
            alert("This Kaje Inward Memo already exists!");
            setMultiData(prevMultiData);

            setTableData([]);
        } else {
            const dval = [...multiData, data];
            setMultiData(dval);


            setFormData(prev => ({
                ...prev,
                kjnId: '',
                kId: '',
                soId: '',
                sono: '',
                itemId: '',
                item: '',
                totQty: '',
                totissqty: '',
                kjMemo: '',
                mcloth: '',
                m1cloth: '',
                m2cloth: '',
                m3cloth: '',
                mclothNm: '',
                m1clothNm: '',
                m2clothNm: '',
                m3clothNm: '',
                mtotqty: parseFloat(prev.mtotqty) + parseFloat(formData.totQty),
                mtotissqty: parseFloat(prev.mtotissqty) + parseFloat(formData.totissqty),
                trMemo: parseFloat(prev.trMemo) + 1,
            }));
            setTableData([]);
        }
        // Check if the kjnId already exists in the previous state
        // setMultiData(prev => {
        //     // Check if the kjnId already exists
        //     const isKjnIdExist = prev.some(item => item.kjnId === data.kjnId);

        //     if (isKjnIdExist) {
        //         // If kjnId exists, alert the user and return the previous state unchanged
        //         alert("This Kaje Inward Memo already exists!");
        //         return prev;
        //     } else {
        //         // If kjnId doesn't exist, add the new data to the array
        //         return [...prev, data];
        //     }
        // });

        // const filterData = returnMemo?.kstMemo?.filter((item) => item.ID !== formData.sreId);
    };

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/trimming-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    // Handle single row checkbox
    const handleCheckboxChange = (index) => {
        if (selectedRows.includes(index)) {
            // remove from selected
            setSelectedRows(selectedRows.filter(i => i !== index));
        } else {
            // add to selected
            setSelectedRows([...selectedRows, index]);
        }
    };

    // Handle "select all" checkbox
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // select all indices
            setSelectedRows(multiData.map((_, i) => i));
        } else {
            // deselect all
            setSelectedRows([]);
        }
    };

    // Remove selected rows
    const handleRemoveSelected = () => {
        const updated = multiData?.filter((_, i) => !selectedRows.includes(i));
        const updated2 = multiData?.filter((_, i) => selectedRows.includes(i));
        // console.log(updated2);
        const totqty = updated2?.reduce((acc, sum) => acc + parseFloat(sum.totqty), 0);
        const totissqty = updated2?.reduce((acc, sum) => acc + parseFloat(sum.totissqty), 0);
        setMultiData(updated); // update state
        setSelectedRows([]);   // reset selected
        setFormData(prev => ({
            ...prev,
            mtotqty: parseFloat(prev.mtotqty) - totqty,
            mtotissqty: parseFloat(prev.mtotissqty) - totissqty,
            trMemo: parseFloat(prev.trMemo) - 1,
        }));

    };

    function convertIntoOneObject(multiData, formData) {
        const data = {
            userId: formData.userId,
            dt: formData.dt,
            trMemo: formData.trMemo,
            firmId: formData.firmId,
            multiData: multiData,
            empId: formData.empId
        };
        return data;
    }
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.empId.trim() === '') {
            alert('Select Employee');
        } else {
            setLoading(true);

            try {
                const finalObject = convertIntoOneObject(multiData, formData);
                // console.log(finalObject);

                const result = await dispatch(InsertTrimming(finalObject)).unwrap();
                console.log('POST request successful!', result);
                // toast.success("Trimming Added");
                alert("Trimming Issue Added Successfully....!!!");
                window.location.reload();
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <>
            <TitleBar data={TrimmingMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Trimming Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>


                                {fields?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                {
                                    dropdownEmployeelist && dropdownEmployeelist?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {fields2?.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {[
                                    { label: 'Instructions', name: 'instructions' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        style={{ ...styled.input, width: '100%' }}
                                                        readOnly={field.type === 'readOnly'}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {tableData?.length > 0 && (
                                    <Grid item xs={10} md={11}>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Kaje Inward Qty</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Issue Qty</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Bal Qty</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>

                                                    {tableData?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.size}
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.tqty}
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                <input
                                                                    type="text"
                                                                    value={item.tissqty}
                                                                    placeholder="0"
                                                                    onChange={(e) => handleQtychange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.tbalqty}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}


                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                )}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleAddData} disabled={tableData?.length === 0}>Add</Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        onClick={handleRemoveSelected}
                                        disabled={selectedRows.length === 0}
                                    >
                                        Remove
                                    </Button>
                                </Grid>

                                {multiData.length > 0 && (
                                    <Grid item xs={10} md={11}>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedRows.length === multiData.length && multiData.length > 0}
                                                                onChange={handleSelectAll}
                                                            /> Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Trimming Memo</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Kaje Inward Memo</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>SO No.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Item</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Total Kaje Inw Qty</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Total Issue Qty</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>View</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>

                                                    {multiData?.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                />
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.trMemo}
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.kreMemo}
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.sono}
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.itemNm}
                                                            </TableCell>

                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.totqty}
                                                            </TableCell>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {item.totissqty}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(item)} />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                    <TableRow>
                                                        <TableCell
                                                            sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >

                                                        </TableCell>
                                                        <TableCell
                                                            sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >

                                                        </TableCell>
                                                        <TableCell
                                                            sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >

                                                        </TableCell>
                                                        <TableCell
                                                            sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >
                                                            Total
                                                        </TableCell>

                                                        <TableCell
                                                            sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >
                                                            {formData.mtotqty}
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >
                                                            {formData.mtotissqty}
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>

                                                        </TableCell>
                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                )}

                                {multiData?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}

                                <ToastContainer />
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default TrimmingEntry;
